export default function TableStatusComponent({color, status, count}) {
    const dotStyle = {
      backgroundColor: color
    }
    return (
      <div className="flex flex-row items-center gap-2 font-medium">
        <div className={`w-[10px] h-[10px] rounded-[5px]`} style={dotStyle}/>
        <div className="text-[13px]">{status}</div>
        <div className="text-[13px]">{`[ ${count} ]`}</div>
      </div>
    )
}